import {ShowPageActions} from "./Pages/ShowPageActions";
import {NavigateFunction} from "react-router-dom";
import {DropDownIdentifier, PledgerAppActions} from "@pledger/frontend-commons";


export const AppActions = {
    ...PledgerAppActions,

    GO_BACK_ACTION : { type : 'AppActions.GO_BACK_ACTION', build:(navigate? : NavigateFunction) => {return {type: AppActions.GO_BACK_ACTION.type, payload:{navigate}, loggable:true }}},

    // retour à la page suivante
    GO_FORWARD_ACTION : { type : 'AppActions.GO_FORWARD_ACTION', build:(navigate? : NavigateFunction) => {return {type: AppActions.GO_FORWARD_ACTION.type, payload:{navigate}, loggable:true }}},


    // // Demande de chargement des notifications pour usage dans le popup
    RELOAD_NOTIFICATIONS_ACTION : { type : 'AppActions.RELOAD_NOTIFICATIONS_ACTION', build : () => {return {type: AppActions.RELOAD_NOTIFICATIONS_ACTION.type, loggable:true}}},


    ...ShowPageActions,

    DISPLAY_BASE64_DOCUMENT_ACTION : { type : 'AppActions.DISPLAY_BASE64_DOCUMENT_ACTION', build : (docName : string,docData : string,typeMime : string,docWindow : Window) => {return {type: AppActions.DISPLAY_BASE64_DOCUMENT_ACTION.type, payload:{docName,docData,typeMime,docWindow}}}},

    SET_BREADCRUMP_STEP_ACTION : { type : 'AppActions.SET_BREADCRUMP_STEP_ACTION', build : (step:number) => {return {type: AppActions.SET_BREADCRUMP_STEP_ACTION.type, payload:{step}}}},

    REGISTER_SIMULATION_ID_ACTION : { type : 'AppActions.REGISTER_SIMULATION_ID_ACTION', build : (simulationId:string) => {return {type: AppActions.REGISTER_SIMULATION_ID_ACTION.type, payload:{simulationId}}}},

    CLOSE_ALL_DROPDOWN_ACTION: { type : 'AppActions.CLOSE_ALL_DROPDOWN_ACTION', build : () => {return {type: AppActions.CLOSE_ALL_DROPDOWN_ACTION.type, payload:{}}}},
    TOGGLE_DROPDOWN_ACTION: { type : 'AppActions.TOGGLE_DROPDOWN_ACTION', build : (dropdownId : DropDownIdentifier) => {return {type: AppActions.TOGGLE_DROPDOWN_ACTION.type, payload:{dropdownId}}}},

    OPEN_BURGER_MENU_ICON_ACTION: { type : 'AppActions.OPEN_BURGER_MENU_ICON_ACTION', build : () => {return {type: AppActions.OPEN_BURGER_MENU_ICON_ACTION.type, payload:{}}}},
    CLOSE_BURGER_MENU_ICON_ACTION: { type : 'AppActions.CLOSE_BURGER_MENU_ICON_ACTION', build : () => {return {type: AppActions.CLOSE_BURGER_MENU_ICON_ACTION.type, payload:{}}}},

};







